import { createAction, createAsyncAction } from "typesafe-actions";
import type { FetchError } from "app/pages/sales-intelligence/types";
import type {
    IntentSelectedTopicDto,
    IntentTopicDescriptionDto,
    IntentTopicDto,
    SaveIntentTopicResponseDto,
} from "app/pages/sales-intelligence/sub-modules/intent/types/dto";
import type {
    IntentApprovedTerms,
    SearchIntentParams,
    Topic,
} from "app/pages/sales-intelligence/sub-modules/intent/types/common";

const INTENT_MANAGEMENT_MODULE = "intentManagement";

export const fetchIntentCategories = createAsyncAction(
    `@@si/${INTENT_MANAGEMENT_MODULE}/FETCH_INTENT_CATEGORY_REQUEST`,
    `@@si/${INTENT_MANAGEMENT_MODULE}/FETCH_INTENT_CATEGORY_SUCCESS`,
    `@@si/${INTENT_MANAGEMENT_MODULE}/FETCH_INTENT_CATEGORY_FAILURE`,
)<void, IntentTopicDescriptionDto, FetchError>();

export const fetchIntentUserAdmins = createAsyncAction(
    `@@si/${INTENT_MANAGEMENT_MODULE}/FETCH_INTENT_USER_ADMINS_REQUEST`,
    `@@si/${INTENT_MANAGEMENT_MODULE}/FETCH_INTENT_USER_ADMINS_SUCCESS`,
    `@@si/${INTENT_MANAGEMENT_MODULE}/FETCH_INTENT_USER_ADMINS_FAILURE`,
)<void, string[], FetchError>();

export const fetchIntentTopics = createAsyncAction(
    `@@si/${INTENT_MANAGEMENT_MODULE}/FETCH_INTENT_TOPICS_REQUEST`,
    `@@si/${INTENT_MANAGEMENT_MODULE}/FETCH_INTENT_TOPICS_SUCCESS`,
    `@@si/${INTENT_MANAGEMENT_MODULE}/FETCH_INTENT_TOPICS_FAILURE`,
)<void, IntentTopicDto, FetchError>();

export const fetchSelectedIntentTopics = createAsyncAction(
    `@@si/${INTENT_MANAGEMENT_MODULE}/FETCH_SELECTED_INTENT_TOPICS_REQUEST`,
    `@@si/${INTENT_MANAGEMENT_MODULE}/FETCH_SELECTED_INTENT_TOPICS_SUCCESS`,
    `@@si/${INTENT_MANAGEMENT_MODULE}/FETCH_SELECTED_INTENT_TOPICS_FAILURE`,
)<void, IntentSelectedTopicDto, FetchError>();

export const saveIntentTopics = createAsyncAction(
    `@@si/${INTENT_MANAGEMENT_MODULE}/SAVE_INTENT_TOPICS_REQUEST`,
    `@@si/${INTENT_MANAGEMENT_MODULE}/SAVE_INTENT_TOPICS_SUCCESS`,
    `@@si/${INTENT_MANAGEMENT_MODULE}/SAVE_INTENT_TOPICS_FAILURE`,
)<void, SaveIntentTopicResponseDto, FetchError>();

export const fetchIntentManagementApproval = createAsyncAction(
    `@@si/${INTENT_MANAGEMENT_MODULE}/FETCH_INTENT_MANAGEMENT_APPROVAL_REQUEST`,
    `@@si/${INTENT_MANAGEMENT_MODULE}/FETCH_INTENT_MANAGEMENT_APPROVAL_SUCCESS`,
    `@@si/${INTENT_MANAGEMENT_MODULE}/FETCH_INTENT_MANAGEMENT_APPROVAL_FAILURE`,
)<void, IntentApprovedTerms, FetchError>();

export const saveIntentManagementApproval = createAsyncAction(
    `@@si/${INTENT_MANAGEMENT_MODULE}/SAVE_INTENT_MANAGEMENT_APPROVAL_REQUEST`,
    `@@si/${INTENT_MANAGEMENT_MODULE}/SAVE_INTENT_MANAGEMENT_APPROVAL_SUCCESS`,
    `@@si/${INTENT_MANAGEMENT_MODULE}/SAVE_INTENT_MANAGEMENT_APPROVAL_FAILURE`,
)<void, void, FetchError>();

export const setSearchObjectCategories = createAction(`@@si/${INTENT_MANAGEMENT_MODULE}/SET_SEARCH_OBJ_CATEGORIES`)<
    string[]
>();

export const setSaveTopicsError = createAction(`@@si/${INTENT_MANAGEMENT_MODULE}/SET_SAVE_TOPICS_ERROR`)<
    FetchError | undefined
>();

export const setSelectedTopics = createAction(`@@si/${INTENT_MANAGEMENT_MODULE}/SET_SELECTED_TOPIC`)<Topic[]>();

export const setFullSearchObject = createAction(
    `@@si/${INTENT_MANAGEMENT_MODULE}/SET_FULL_SEARCH_OBJ`,
)<SearchIntentParams>();
